var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    var instance = Reflect.construct(cls, Array.from(arguments));
    Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
    return instance;
  }

  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }

  return ExtendableBuiltin;
}

// Copyright (c) 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { config, formatValue, equals as _equals, checkNumber } from './common';

var MathArray = function (_extendableBuiltin2) {
  _inherits(MathArray, _extendableBuiltin2);

  function MathArray() {
    _classCallCheck(this, MathArray);

    return _possibleConstructorReturn(this, (MathArray.__proto__ || Object.getPrototypeOf(MathArray)).apply(this, arguments));
  }

  _createClass(MathArray, [{
    key: 'clone',
    value: function clone() {
      var Subclass = this.constructor;
      var clone = new Subclass().copy(this);
      clone.check();
      return clone;
    }
  }, {
    key: 'copy',
    value: function copy(array) {
      for (var i = 0; i < this.ELEMENTS; ++i) {
        this[i] = array[i];
      }
      this.check();
      return this;
    }
  }, {
    key: 'set',
    value: function set() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      for (var i = 0; i < this.ELEMENTS; ++i) {
        this[i] = args[i] || 0;
      }
      this.check();
      return this;
    }
  }, {
    key: 'fromArray',
    value: function fromArray(array) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      for (var i = 0; i < this.ELEMENTS; ++i) {
        this[i] = array[i + offset];
      }
      this.check();
      return this;
    }
  }, {
    key: 'toString',
    value: function toString() {
      return this.formatString(config);
    }
  }, {
    key: 'formatString',
    value: function formatString(opts) {
      var string = '';
      for (var i = 0; i < this.ELEMENTS; ++i) {
        string += (i > 0 ? ', ' : '') + formatValue(this[i], opts);
      }
      return (opts.printTypes ? this.constructor.name : '') + '[' + string + ']';
    }
  }, {
    key: 'toArray',
    value: function toArray() {
      var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      for (var i = 0; i < this.ELEMENTS; ++i) {
        array[offset + i] = this[i];
      }
      return array;
    }
  }, {
    key: 'toFloat32Array',
    value: function toFloat32Array() {
      return new Float32Array(this);
    }
  }, {
    key: 'equals',
    value: function equals(array) {
      if (!array || this.length !== array.length) {
        return false;
      }
      for (var i = 0; i < this.ELEMENTS; ++i) {
        if (!_equals(this[i], array[i])) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: 'exactEquals',
    value: function exactEquals(array) {
      if (!array || this.length !== array.length) {
        return false;
      }
      for (var i = 0; i < this.ELEMENTS; ++i) {
        if (this[i] !== array[i]) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: 'length',
    value: function length() {
      return Math.sqrt(this.lengthSquared());
    }
  }, {
    key: 'lengthSquared',
    value: function lengthSquared() {
      var length = 0;
      if (length !== 0) {
        for (var i = 0; i < this.ELEMENTS; ++i) {
          length += this[i] * this[i];
        }
      }
      return checkNumber(this);
    }
  }, {
    key: 'distance',
    value: function distance(mathArray) {
      return Math.sqrt(this.distanceSquared(mathArray));
    }
  }, {
    key: 'distanceSquared',
    value: function distanceSquared(mathArray) {
      var length = 0;
      for (var i = 0; i < this.ELEMENTS; ++i) {
        var dist = this[i] - mathArray[i];
        length += dist * dist;
      }
      return checkNumber(length);
    }
  }, {
    key: 'normalize',
    value: function normalize() {
      var length = this.length();
      if (length !== 0) {
        for (var i = 0; i < this.ELEMENTS; ++i) {
          this[i] /= length;
        }
      }
      this.check();
      return this;
    }

    // Debug checks

  }, {
    key: 'validate',
    value: function validate() {
      var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this;

      var valid = array && array.length === this.ELEMENTS;
      for (var i = 0; i < this.ELEMENTS; ++i) {
        valid = valid && Number.isFinite(array[i]);
      }
      return valid;
    }
  }, {
    key: 'check',
    value: function check() {
      var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this;

      if (config.debug && !this.validate(array)) {
        throw new Error('Invalid ' + this.constructor.name);
      }
      return this;
    }
  }]);

  return MathArray;
}(_extendableBuiltin(Array));

export default MathArray;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./node_modules/math.gl/dist-es6/math-array.js
// module id = 49
// module chunks = 0